<template>
  <ModalForm
    title="Invite Pilot"
    :show="props.show"
    @submit="submit"
    @close="close"
    :processing="form.processing"
    button="Send Invite"
  >
    <div class="space-y-4">
      <div>
        <InputGroup
          v-model="form.name"
          label="Name"
          :error="form.errors.name"
        />
      </div>
      <div>
        <InputGroup
          v-model="form.email"
          type="email"
          label="Email"
          :error="form.errors.email"
        />
        <InputHelpText
          >They'll get an email with a link to set up their account. If they
          already use AirSchedule, that account is added instead.</InputHelpText
        >
      </div>
    </div>
  </ModalForm>
</template>

<script setup>
import ModalForm from '@/Common/Overlays/Modals/ModalForm.vue'
import InputGroup from '@/Common/Forms/Inputs/InputGroup.vue'
import InputHelpText from '@/Common/Forms/Inputs/InputHelpText.vue'
import { useForm } from '@inertiajs/inertia-vue3'

const props = defineProps({
  show: Boolean,
  plane: Object,
})

const emit = defineEmits(['close'])

const form = useForm({
  name: null,
  email: null,
})

function submit() {
  form.post(route('planes.pilots.store', props.plane), {
    preserveScroll: true,
    onSuccess: () => close(),
  })
}

function close() {
  emit('close')
  form.reset()
  form.clearErrors()
}
</script>
